/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingpostalcode3Inputs */

const en_profilebillingpostalcode3 = /** @type {(inputs: Profilebillingpostalcode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postal code`)
};

const de_profilebillingpostalcode3 = /** @type {(inputs: Profilebillingpostalcode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLZ`)
};

/**
* | output |
* | --- |
* | "Postal code" |
*
* @param {Profilebillingpostalcode3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingpostalcode3 = /** @type {((inputs?: Profilebillingpostalcode3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingpostalcode3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingpostalcode3(inputs)
	return de_profilebillingpostalcode3(inputs)
});
export { profilebillingpostalcode3 as "profileBillingPostalCode" }